module.exports = __webpack_public_path__ + "img/sys-feature.92f389e0.jpg";